import { sp } from '@main/theme';
import React from 'react';

import { RequiredWrapper } from '../wrappers';
import { Description } from './Description';
import type { IFormControlProps } from './Input';
import { StyledFormControl } from './Input';
import { FormItemWrapper, LabelWrapper } from './wrappers';

export const StyledTextArea: React.FC<
  IFormControlProps & {
    /** Multiline input */
    multiline?: number;
  }
> = ({ label, description, multiline, isRequired, ...props }) => (
  <FormItemWrapper>
    <div style={{ alignSelf: 'center', width: `${sp(46)}` }}>
      <LabelWrapper>
        {label}
        {isRequired && <RequiredWrapper>*</RequiredWrapper>}
        {description && (
          <Description
            descriptionHtml={description}
            id={`${props.name}-description`}
          />
        )}
      </LabelWrapper>
      <StyledFormControl
        forwardedAs="textarea"
        {...props}
        multiple={multiline}
      />
    </div>
  </FormItemWrapper>
);
